import { render, staticRenderFns } from "./provide.vue?vue&type=template&id=be5ab65a&scoped=true&"
import script from "./provide.vue?vue&type=script&lang=js&"
export * from "./provide.vue?vue&type=script&lang=js&"
import style0 from "./provide.vue?vue&type=style&index=0&id=be5ab65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5ab65a",
  null
  
)

component.options.__file = "provide.vue"
export default component.exports